import { render, staticRenderFns } from "./SubscribeToNewsletterInFooter.vue?vue&type=template&id=0c2e4de8&scoped=true"
import script from "./SubscribeToNewsletterInFooter.vue?vue&type=script&lang=js"
export * from "./SubscribeToNewsletterInFooter.vue?vue&type=script&lang=js"
import style0 from "./SubscribeToNewsletterInFooter.vue?vue&type=style&index=0&id=0c2e4de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e4de8",
  null
  
)

export default component.exports